import { ColorSchemes } from './enums';

export const DEFAULT_COLOR_SCHEME = ColorSchemes.LIGHT;
